import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getFlatMeterTariffs = async () => {
  return await request.get(
    `/Meter/individual_meter_tariffs`,
    {},
    'При загрузке тарифов для счетчиков произошла ошибка'
  );
};

const useFlatMeterTariffs = (options) =>
  useQuery(getQueryKeys.flatMeterTariffs(), getFlatMeterTariffs, options);

export default useFlatMeterTariffs;
